var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 2.5H1.66667C0.75 2.5 0 3.25 0 4.16667V15.8333C0 16.75 0.75 17.5 1.66667 17.5H18.3333C19.25 17.5 19.9917 16.75 19.9917 15.8333L20 4.16667C20 3.25 19.25 2.5 18.3333 2.5ZM18.3333 15.8333H1.66667V4.16667H18.3333V15.8333ZM15.8417 14.9917L17.5 13.3333L16.2417 11.6667H14.875C14.6917 11.1417 14.5833 10.5833 14.5833 10C14.5833 9.41667 14.6917 8.85833 14.875 8.33333H16.2417L17.5 6.66667L15.8417 5.00833C14.75 5.825 13.9417 6.98333 13.5667 8.33333C13.4167 8.86667 13.3333 9.425 13.3333 10C13.3333 10.575 13.4167 11.1333 13.5667 11.6667C13.9417 13.0083 14.75 14.175 15.8417 14.9917ZM7.5 10C8.875 10 10 8.875 10 7.5C10 6.125 8.875 5 7.5 5C6.125 5 5 6.125 5 7.5C5 8.875 6.125 10 7.5 10ZM7.5 6.66667C7.95833 6.66667 8.33333 7.04167 8.33333 7.5C8.33333 7.95833 7.95833 8.33333 7.5 8.33333C7.04167 8.33333 6.66667 7.95833 6.66667 7.5C6.66667 7.04167 7.04167 6.66667 7.5 6.66667ZM12.5 13.825C12.5 11.7417 9.19167 10.8417 7.5 10.8417C5.80833 10.8417 2.5 11.7417 2.5 13.825V15H12.5V13.825ZM4.56667 13.3333C5.18333 12.9167 6.41667 12.5 7.5 12.5C8.58333 12.5 9.80833 12.9083 10.4333 13.3333H4.56667Z",
    fill: "#396D87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallLog);
export default __webpack_public_path__ + "static/media/CallLog.2f09dc6eccecb13caf85747b6b77801c.svg";
export { ForwardRef as ReactComponent };